import {
  CanvasSidebarAssets
} from "./chunk-4FHQXWXN.js";
import {
  PanelCloseButton
} from "./chunk-W22Y52AU.js";
import {
  PanelMaximizeButton,
  panelDragHandle
} from "./chunk-7UHMFDJC.js";
import {
  Button
} from "./chunk-QXEA2YZ6.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/canvas/files-panel/files-panel.tsx
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function FilesPanel({
  onClose,
  modelCount,
  modelsContent,
  defaultOpen = true,
  onOpenChange,
  className,
  ...assetsProps
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [activeTab, setActiveTab] = useState("files");
  const handleToggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    onOpenChange?.(next);
  };
  const fileCount = assetsProps.files.length;
  const hasModels = modelsContent !== void 0;
  const headerText = "File Manager";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "region",
      "aria-label": "File Manager",
      "data-panel-collapsed": !isOpen,
      className: cn(
        "bg-popover text-popover-foreground border border-border rounded-lg w-[360px] max-w-full flex flex-col overflow-hidden shadow-float",
        isOpen ? "flex-1 min-h-0" : "flex-shrink-0",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { ...panelDragHandle("File Manager"), className: "flex items-center justify-between px-2 py-1 flex-shrink-0", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-1 items-center gap-1.5", children: [
            /* @__PURE__ */ jsx(Icon, { name: "folder", className: "h-4 w-4 text-muted-foreground" }),
            /* @__PURE__ */ jsx("p", { className: "text-sm font-normal text-foreground truncate", children: headerText })
          ] }),
          /* @__PURE__ */ jsx(PanelMaximizeButton, {}),
          onClose && /* @__PURE__ */ jsx(PanelCloseButton, { title: "File Manager", onClose }),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              "aria-label": `${isOpen ? "Collapse" : "Expand"} File Manager`,
              "aria-expanded": isOpen,
              onClick: handleToggle,
              className: "h-6 w-6 p-1 bg-muted rounded-[6px] hover:bg-accent",
              children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: isOpen ? "chevron-up" : "chevron-down",
                  className: "h-4 w-4 text-foreground"
                }
              )
            }
          )
        ] }),
        isOpen && hasModels && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1 px-2 pb-1 flex-shrink-0 overflow-x-auto whitespace-nowrap", children: [
          /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              "aria-pressed": activeTab === "files",
              onClick: () => setActiveTab("files"),
              className: cn(
                "px-3 py-1 text-xs rounded-md transition-colors",
                activeTab === "files" ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              ),
              children: [
                "Files (",
                fileCount,
                ")"
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              "aria-pressed": activeTab === "models",
              onClick: () => setActiveTab("models"),
              className: cn(
                "px-3 py-1 text-xs rounded-md transition-colors",
                activeTab === "models" ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              ),
              children: [
                "Models (",
                modelCount ?? 0,
                ")"
              ]
            }
          )
        ] }),
        isOpen && /* @__PURE__ */ jsx("div", { className: "flex-1 min-h-0 overflow-hidden flex flex-col", children: activeTab === "files" || !hasModels ? /* @__PURE__ */ jsx(CanvasSidebarAssets, { ...assetsProps }) : modelsContent })
      ]
    }
  );
}

export {
  FilesPanel
};
//# sourceMappingURL=chunk-OYSJTHL7.js.map